import { UserInterface } from '@actassa/api';

export class LoginSuccess {
    public static readonly type = '[RootState] Login success';

    constructor(public payload: UserInterface) { }
}
